<itl-section [title]="TemplateNodeTitle || ('integratedCareReturnDelivery.detail.articles' | translate)">
  <div *ngFor="let articleData of articles">
    <itl-integratedcare-article [article]="articleData.article" isWizardPage="true" [icon]="'alberta-article'">
      <ng-container slot="dosage"> {{ articleData?.quantity }} {{ articleData?.unit | articleUnitPipe }} </ng-container>
    </itl-integratedcare-article>
  </div>
</itl-section>
